/** @prettier */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { setMultiplesTab } from '@xanadu/ui-shared/modules/multiples/actions';

import Multiples from '../../components/Multiples';

const mapDispatchToProps = {
  setMultiplesTab,
};

function mapStateToProps(state) {
  return {
    available: state.getIn(['multiples', 'available']),
    multipleBuild: state.getIn(['multiples', 'build']),
    buildSubmitted: state.getIn(['multiples', 'submitted']),
    isLoggedIn: state.getIn(['user', 'isLoggedIn']),
    sidebarContent: state.getIn(['rightSidebar', 'content']),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Multiples));
